const getters = {
	activeAuction: state => state.activeAuction,
    auctions: state => state.auctions,
    auctionItems: state => state.auctionItems
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/auction/getters.js